import React from 'react';
import {Button, Card, Loader} from 'semantic-ui-react';
import {UploadFile} from './uploadFile/uploadFile';
import {useDispatch, useSelector} from 'react-redux';
import TableValidateData from './validation/tableValidatedData';
import {Actions} from '../../../common/actions';
import './styles.scss';
import AdditionalErrors from './validation/additionalErrors';
import {paths} from '../../../common/dictionaries/urls';

const {cleanPricesValidationData, navigateTo, saveMultipleColorPrices} = Actions;

const VehiclesPriceColorLoad = () => {
  const dispatch = useDispatch();

  const {'data': validatedData, loading} = useSelector((state) => state.vehiclesPriceColorLoad.validatedData);

  const handleSubmit = () => {
    dispatch(saveMultipleColorPrices(validatedData?.data));
  };
  
  return (
    <div>
      <Card raised fluid>
        <div className='title-bar'>
          <div className='title'>
            <h2>Cargar información de costos</h2>
            <div className="title-bar-actions">
              <Button
                basic
                onClick={() => {
                  dispatch(cleanPricesValidationData());
                  dispatch(navigateTo(paths.VehiclesMaintenance));
                }}
              >
                SALIR
              </Button>
              {validatedData &&
              <>
                <Button
                  basic
                  onClick={() => dispatch(cleanPricesValidationData())}>LIMPIAR</Button>
                <Button
                  primary
                  color='red'
                  onClick={handleSubmit}
                  disabled={(validatedData && validatedData?.errors)}
                >
                  GUARDAR
                </Button>
              </>
              }
            </div>
          </div>
        </div>
      </Card>
      { loading ? <Card fluid className='color-prices__loading-card'><Loader active inline='centered' /></Card> :
        <>
          {validatedData ?
            <Card fluid>
              <TableValidateData
                dataTable={validatedData?.data}
              />
            </Card> :
            <Card fluid raised className='color-prices-load__drop_data'>
              <UploadFile />
            </Card>
          }
        </>
      }
      {(validatedData?.noAvailableColors || validatedData?.errorsDatesRanges) &&
        <AdditionalErrors
          additionalData={validatedData?.noAvailableColors}
          errorsDatesRanges={validatedData?.errorsDatesRanges}
        />
      }
    </div>
  );
};

export default VehiclesPriceColorLoad;
